import React, { useState } from 'react'
import { printPackageHasProductIssue } from '../../Common/PrintStamp/actions'
import { Button } from 'antd'
import { trans } from '../../../system/i18n'
import { dispatch } from '../../../system/store'

function PrintPackageHasProductIssueStampButton(props) {
    const [loading, setLoading] = useState(false)
    async function doPrint() {
        const { packageData, packageItems, packageDamagedReasons} = props
        setLoading(true)
        await dispatch(printPackageHasProductIssue({ packageData, packageItems, packageDamagedReasons }))
        setLoading(false)
    }
    return (
        <Button
            loading={loading}
            onClick={doPrint}>
            {trans('package:btn.print_package_has_product_issue')}
        </Button>
    )
}
export default PrintPackageHasProductIssueStampButton
